export default "__VITE_ASSET__CeUJKZrw__"